<template>
  <div class="dashboard clearfix">
    <div class="welcome">
      <p>
        Hej <span>{{ user.firstName }}</span>
      </p>
      <p v-if="$texts.dashboardWelcome" v-html="$texts.dashboardWelcome"></p>
      <p v-else>Velkommen til fordelsprogrammet. Her kan du se, hvor du har optjent og se hvad din saldo er.</p>
    </div>
    <div class="dashboard-profile">
      <div class="balance">
        <div>
          <span class="point-title">
            Min saldo <span class="point-num">{{ balance | normalizeBalance | localizeCurrency }}</span>
          </span>
          <span class="status">Status {{ balanceDate }}</span>
          <div class="payout">
            <div v-if="balance >= 100" class="btn-box"><a class="btn-red" :href="$settings.withdrawal_redirect_url" target="_blank">Udbetal</a></div>
            <div v-else class="disable-balance">
              <span
                v-tooltip="{
                  content: `Du kan udbetale din saldo <br /> så snart du har optjent 100 kr.`,
                  placement: 'bottom-center',
                }"
                class="btn-gray"
              >
                Udbetal
              </span>
            </div>
          </div>
        </div>
      </div>
      <transactions limit="4" showAllLink></transactions>
      <payment-cards :perPage="1" title="Tilknyttede kort"></payment-cards>
    </div>
  </div>
</template>

<script>
import PaymentCards from 'Components/Partials/PaymentCards'
import Transactions from 'Components/Partials/Transactions'
import User from 'cashback-api-js/Resources/User'
import {format} from 'date-fns'

export default {
  name: 'Dashboard',

  components: {
    PaymentCards,
    Transactions,
  },

  data() {
    return {
      balance: 0,
      balanceDate: format(new Date(), 'dd.MM.yyyy'),
      user: new User(),
      showPayout: false,
      owner: '',
      ownerTryg: false,
    }
  },

  mounted() {
    this.getUser()
    this.getBalance()
  },

  methods: {
    getUser() {
      this.$cashback
        .user()
        .then((user) => {
          this.user = user
          this.owner = user.data.security.roles
          this.ownerTryg = this.owner.includes('TrygUser')
          this.$emit('loaded')
        })
        .catch((error) => {})
    },

    getBalance() {
      this.$cashback
        .wallets()
        .then((data) => {
          let walletDKK = data.items.find(function (item) {
            return item.currency === 'DKK'
          })
          this.balance = Math.max(0, walletDKK.balance)
        })
        .catch((error) => {})
    },
  },
}
</script>
